export default __webpack_public_path__ + "static/media/landing-bg.96c966e9.jpg";